var map = {
	"./overview/hdb-overview-desktop.png": "dc9a",
	"./overview/hdb-overview.png": "4056",
	"./profiles/1970-1-desktop.jpg": "7d22",
	"./profiles/1970-1.jpg": "c642",
	"./profiles/1970-2-desktop.jpg": "0adc",
	"./profiles/1970-2.jpg": "f66c",
	"./profiles/1970-3-desktop.jpg": "8cf7",
	"./profiles/1970-3.jpg": "11d9",
	"./profiles/1970-4-desktop.jpg": "cb2d",
	"./profiles/1970-4.jpg": "482d",
	"./profiles/1970s-desktop.png": "7c94",
	"./profiles/1970s.png": "4de6",
	"./profiles/2020-1-desktop.jpg": "ebc7",
	"./profiles/2020-1.jpg": "604e",
	"./profiles/2020-2-desktop.jpg": "fc0f",
	"./profiles/2020-2.jpg": "2f94",
	"./profiles/2020-3-desktop.jpg": "0f65",
	"./profiles/2020-3.jpg": "7a72",
	"./profiles/2020-4-desktop.jpg": "b6a1",
	"./profiles/2020-4.jpg": "90fc",
	"./profiles/2020-main-1-desktop.jpg": "52cb",
	"./profiles/2020-main-1.jpg": "5973",
	"./profiles/2020-main-2-desktop.jpg": "b983",
	"./profiles/2020-main-2.jpg": "598c",
	"./profiles/2020-main-3-desktop.jpg": "8d03",
	"./profiles/2020-main-3.jpg": "2ea4",
	"./profiles/2020-main-4-desktop.jpg": "00f6",
	"./profiles/2020-main-4.jpg": "bac8",
	"./profiles/2020-main-5-desktop.jpg": "e8b0",
	"./profiles/2020-main-5.jpg": "9e1c",
	"./profiles/2020-main-6-desktop.jpg": "bfe5",
	"./profiles/2020-main-6.jpg": "8931",
	"./profiles/2020s-desktop.png": "0e1d",
	"./profiles/2020s.png": "0c82",
	"./small-multiples/desktop.svg": "62ad",
	"./small-multiples/mobile.svg": "8bc5",
	"./small-multiples/tablet.svg": "0e26",
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";